export default {
	chat_not_found_by_protocol_id: "Nenhum chat encontrado para esse protocolo"
}
